import React from 'react';
import './MeterReadingTarif.less';
import { shortenObis } from '../../../helper/MeterHelper';

// The wrapper box width (computed in JobDetails) budgets ~13px per character,
// which matches lowercase text. The label is rendered uppercase (~16-17px per
// character at text-2xl), so labels of 6+ characters (e.g. "WASSER") overflow
// the box and get chopped mid-word. Shrinking the font for longer labels keeps
// them on one line WITHOUT widening the box — so the reading input next to it
// does not move.
export const tarifFontSizeClass = (text: string | undefined): string =>
    (text?.length ?? 0) >= 6 ? 'text-lg' : 'text-2xl';

const MeterReadingTarif = ({ obis, rateName }: { obis?: string, rateName?: string }) => {

    if(!obis && !rateName)
        return null;

    if (!rateName) {
        const obisText = shortenObis(obis);
        return (
            <div className='meter-reading-tarif inline-block mr-6'>
                <div className={'flex flex-col leading-none'}>
                    <span aria-label={"Tarifbezeichnung (OBIS)"} className={`${tarifFontSizeClass(obisText)} font-medium leading-none`}>{obisText}</span>
                </div>
            </div>
        );
    }

    return (
        <div className='meter-reading-tarif inline-block mr-6'>
            <div className={'flex flex-col leading-none'}>
                <span aria-label={'Tarifname'} className={`${tarifFontSizeClass(rateName)} font-medium leading-none`}>{rateName}</span>
                <span aria-label={'Tarifbezeichnung (OBIS)'} className={'text-sm leading-none'}>{shortenObis(obis)}</span>
            </div>
        </div>
    );
};

export default MeterReadingTarif;
